










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";

@Component({ name: "ProfileTagsView" })
export default class ProfileTagsView extends Vue {
  @Prop({ type: Array, required: true })
  public readonly userTags!: TagInfo[];
}
